export default __webpack_public_path__ + "static/media/nav-close-tab-popover.11b698b8.svg";